function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
/* eslint-disable default-param-last, jsx-a11y/control-has-associated-label, react/no-unused-class-component-methods */ import React from 'react';
import { FormattedMessage } from 'react-intl';
import PropTypes from 'prop-types';
import cn from 'classnames';
import ReactTooltip from 'react-tooltip';
import { AnimatePresence, motion } from 'framer-motion';
import isEmpty from 'lodash/isEmpty';
import camelCase from 'lodash/camelCase';
import { AppContext } from 'context';
import Button from 'components/Form/Button';
import App, { LanguageSelector } from 'modules/App';
import intlShape from 'shapes/intlShape';
import Help from 'svg/help.svg';
import Chevron from 'svg/chevron-right.svg';
import Dots from 'svg/dots.svg';
import MenuExtend from 'svg/menu-extend.svg';
import MenuCollapse from 'svg/menu-collapse.svg';
import messages from '../../../messages';
import * as constants from '../../../constants';
import CurrentVersion from '../../../partials/CurrentVersion';
var _React_Component;
class Sidebar extends (_React_Component = React.Component) {
    onHoverExit() {
        this.setState({
            hovered: ''
        });
    }
    onHover(name) {
        this.setState({
            hovered: name
        });
    }
    onToggleMenu() {
        this.onSetMenuOpen(!this.props.menuOpen);
    }
    onCloseSelectedMenu() {
        this.onSelectMenuItem(null);
    }
    onHideAllMenu() {
        if (!this.props.isPinnedMenu) {
            this.onSetMenuOpen(false);
        }
        this.onSelectMenuItem(null);
    }
    onClickDisabled(evt) {
        evt.preventDefault();
        this.onHideAllMenu();
    }
    onSelectMenuItem(item) {
        this.props.setSelectedMenuItem(this.props.selectedMenuItem !== item ? item : null);
    }
    onSetMenuOpen(isMenuOpen) {
        this.props.setMenuOpen(isMenuOpen);
    }
    get isOpenMenu() {
        return this.props.menuOpen && !this.props.activeVisit;
    }
    get isOpenSelectedMenu() {
        return !isEmpty(this.props.selectedMenuItem) && !this.props.activeVisit;
    }
    get isShrinkedMenu() {
        return !this.isOpenMenu && !this.isOpenSelectedMenu;
    }
    // STARTS METHODS TO OVERRIDE IN CHILDREN
    get menuItems() {
        return [];
    }
    get menuItemsSelected() {
        return {};
    }
    // END METHODS TO OVERRIDE IN CHILDREN
    isSelectedMenuItem(item) {
        return this.props.selectedMenuItem === item;
    }
    renderSelectedMenuHeader(name) {
        const title = /*#__PURE__*/ _jsx("span", {
            className: "sidebar__elementContentExtend--title",
            children: /*#__PURE__*/ _jsx(FormattedMessage, _object_spread({}, messages.sidebar.buttons[name]))
        });
        return /*#__PURE__*/ _jsx(_Fragment, {
            children: this.renderMenuButtonItem(`${name}-header`, 1, title, ()=>this.onCloseSelectedMenu())
        });
    }
    renderMenuButtonItem(name, index, menuItem, onClick = ()=>{}, selected, to, noHover) {
        const { activeVisit, intl } = this.props;
        if (activeVisit) {
            onClick = (evt)=>this.onClickDisabled(evt);
        }
        const tooltipText = activeVisit ? intl.formatMessage(App.messages.infos.menuDisabledIfActiveVisit) : name;
        const isHovered = name === this.state.hovered && !activeVisit && !noHover;
        return /*#__PURE__*/ _jsx(Button, {
            styleModifier: "transparent",
            className: "sidebar__element",
            onClick: onClick,
            type: to ? 'link' : 'button',
            to: to,
            children: /*#__PURE__*/ _jsx("div", {
                className: cn('sidebar__elementContent', {
                    'sidebar__elementContent--selected': selected && !to,
                    sidebar__elementContentExtend: index === 1,
                    sidebar__elementShrinked: index === 0,
                    'sidebar__elementContentExtend--selected': selected && index === 1 && !to,
                    'sidebar__elementContent--linkSelected': selected && to && index === 0 && !isHovered,
                    'sidebar__elementContentExtend--linkSelected': selected && to && index === 1 && !isHovered,
                    'sidebar__elementContent--hovered': isHovered,
                    'sidebar__elementContent--disabled': activeVisit
                }),
                onMouseEnter: ()=>this.onHover(name),
                onMouseLeave: ()=>this.onHoverExit(),
                "data-for": "sidebar",
                "data-tip": tooltipText,
                children: menuItem
            })
        }, `menu-item-${camelCase(name)}-${index}`);
    }
    renderMenuButtonItems(name, menuItems, onClick = ()=>this.onHideAllMenu(), selected, to) {
        return menuItems.map((item, index)=>this.renderMenuButtonItem(name, index, item, onClick, selected, to));
    }
    renderHr(key) {
        return [
            /*#__PURE__*/ _jsx("hr", {}, `hr-${key}-1`),
            /*#__PURE__*/ _jsx("hr", {}, `hr-${key}-2`)
        ];
    }
    renderAnimatedChevron(selected) {
        const { direction } = this.props;
        return /*#__PURE__*/ _jsx(motion.div, {
            initial: {
                '--rotate': direction === 'ltr' ? '0deg' : '180deg'
            },
            animate: selected ? constants.VARIANTS_TYPE.OPEN : constants.VARIANTS_TYPE.CLOSED,
            variants: constants.ANIMATION_VARIANTS_CHEVRON[direction],
            className: "d-flex justify-content-center align-items-center",
            children: /*#__PURE__*/ _jsx(Chevron, {})
        });
    }
    renderOptions(onClick = ()=>{}, Menu) {
        return /*#__PURE__*/ _jsxs("div", {
            className: "sidebar__dots",
            children: [
                /*#__PURE__*/ _jsx("div", {
                    onClick: (evt)=>{
                        evt.preventDefault();
                        evt.stopPropagation();
                        onClick();
                    },
                    onKeyDown: ()=>{},
                    className: "d-flex justify-content-center align-items-center",
                    children: /*#__PURE__*/ _jsx(Dots, {})
                }),
                /*#__PURE__*/ _jsx(Menu, {})
            ]
        });
    }
    renderMoreCell(count, key) {
        const text = count > 99 ? '99+' : `+${count}`;
        return /*#__PURE__*/ _jsxs("div", {
            className: "sidebar__moreCell",
            children: [
                /*#__PURE__*/ _jsx("div", {
                    className: "sidebar__moreCell--firstBorder"
                }),
                /*#__PURE__*/ _jsx("div", {
                    className: "sidebar__moreCell--secondBorder"
                }),
                /*#__PURE__*/ _jsx("div", {
                    className: "sidebar__moreCell--content",
                    children: text
                })
            ]
        }, key);
    }
    renderMenuHeader() {
        const menuIcon = this.isOpenMenu ? /*#__PURE__*/ _jsx(MenuCollapse, {}) : /*#__PURE__*/ _jsx(MenuExtend, {});
        const menuText = /*#__PURE__*/ _jsx("span", {
            className: "sidebar__elementContentExtend--title",
            children: /*#__PURE__*/ _jsx(FormattedMessage, _object_spread({}, messages.sidebar.buttons.menu))
        });
        return this.renderMenuButtonItems(this.props.intl.formatMessage(messages.sidebar.buttons.menu), [
            menuIcon,
            menuText
        ], ()=>this.onToggleMenu(), false);
    }
    renderItemSelected() {
        return this.menuItemsSelected[this.props.selectedMenuItem];
    }
    renderMenu() {
        const { direction, activeVisit } = this.props;
        return /*#__PURE__*/ _jsxs(motion.div, {
            className: cn('sidebar', {
                'sidebar--disabled': activeVisit
            }),
            animate: this.isShrinkedMenu ? constants.VARIANTS_TYPE.CLOSED : constants.VARIANTS_TYPE.OPEN,
            variants: constants.ANIMATION_VARIANTS[direction].SHRINKED,
            transition: {
                bounce: 0
            },
            children: [
                /*#__PURE__*/ _jsxs("div", {
                    className: cn('sidebar__menuContainer'),
                    children: [
                        this.renderMenuHeader()[0],
                        this.menuItems.map((menuItem)=>menuItem && menuItem[0])
                    ]
                }),
                /*#__PURE__*/ _jsx(LanguageSelector, {
                    hideLabel: true,
                    className: "sidebar__languageSelector",
                    withTooltip: true,
                    tooltipOffset: direction === 'ltr' ? "{ 'left': -16 }" : "{ 'right': -14 }",
                    tooltipPlace: direction === 'ltr' ? 'right' : 'left',
                    activeVisit: activeVisit
                }),
                /*#__PURE__*/ _jsx("a", {
                    href: "https://support.glucocontro.online/hc",
                    target: "_blank",
                    onClick: activeVisit ? (evt)=>this.onClickDisabled(evt) : undefined,
                    children: /*#__PURE__*/ _jsx(Help, {
                        className: "sidebar__help",
                        "data-for": "sidebar",
                        "data-offset": direction === 'ltr' ? "{ 'left': -16 }" : "{ 'right': -14 }",
                        "data-tip": this.props.intl.formatMessage(activeVisit ? App.messages.infos.menuDisabledIfActiveVisit : messages.sidebar.buttons.helpCenter)
                    })
                })
            ]
        });
    }
    renderMenuExpanded() {
        const { direction } = this.props;
        const initialPosition = direction === 'ltr' ? '-400px' : '400px';
        return /*#__PURE__*/ _jsx(AnimatePresence, {
            initial: false,
            children: this.isOpenMenu && /*#__PURE__*/ _jsxs(motion.div, {
                initial: {
                    x: initialPosition
                },
                animate: this.isOpenSelectedMenu ? constants.VARIANTS_TYPE.OPEN : constants.VARIANTS_TYPE.CLOSED,
                variants: constants.ANIMATION_VARIANTS[direction].EXPANDED,
                exit: {
                    x: initialPosition
                },
                className: cn('sidebar__expanded'),
                transition: {
                    bounce: 0
                },
                children: [
                    /*#__PURE__*/ _jsxs("div", {
                        className: cn('sidebar__menuContainer'),
                        children: [
                            this.renderMenuHeader()[1],
                            this.menuItems.map((menuItem)=>menuItem && menuItem[1])
                        ]
                    }),
                    /*#__PURE__*/ _jsx(CurrentVersion, {})
                ]
            })
        });
    }
    renderMenuSelected() {
        const { direction } = this.props;
        return /*#__PURE__*/ _jsx(AnimatePresence, {
            initial: false,
            children: this.isOpenSelectedMenu && /*#__PURE__*/ _jsx(motion.div, {
                initial: {
                    x: direction === 'ltr' ? '-566px' : '566px'
                },
                animate: this.isOpenMenu ? constants.VARIANTS_TYPE.OPEN : constants.VARIANTS_TYPE.CLOSED,
                variants: constants.ANIMATION_VARIANTS[direction].SELECTED,
                exit: {
                    x: direction === 'ltr' ? '-566px' : '566px'
                },
                className: cn('sidebar__selected'),
                transition: {
                    bounce: 0
                },
                children: /*#__PURE__*/ _jsx("div", {
                    className: cn('sidebar__menuContainer'),
                    children: this.renderItemSelected()
                })
            })
        });
    }
    renderTooltip() {
        const { direction } = this.props;
        if (!process.env.BROWSER || this.isOpenMenu) {
            return null;
        }
        return /*#__PURE__*/ _jsx(ReactTooltip, {
            id: "sidebar",
            place: direction === 'ltr' ? 'right' : 'left',
            type: "dark",
            effect: "solid",
            offset: direction === 'ltr' ? {
                left: -10
            } : {
                right: -8
            }
        });
    }
    renderContent() {
        return /*#__PURE__*/ _jsxs("div", {
            id: "menu-sidebar",
            children: [
                this.renderMenu(),
                this.renderMenuExpanded(),
                this.renderMenuSelected(),
                this.renderTooltip()
            ]
        });
    }
    constructor(props){
        super(props);
        this.state = {
            hovered: ''
        };
        this.styles = {};
    }
}
_define_property(Sidebar, "contextType", AppContext);
_define_property(Sidebar, "propTypes", {
    // Explicit props
    direction: PropTypes.string,
    menuOpen: PropTypes.bool,
    selectedMenuItem: PropTypes.string,
    activeVisit: PropTypes.object,
    isPinnedMenu: PropTypes.bool,
    // Explicit actions
    setMenuOpen: PropTypes.func,
    setSelectedMenuItem: PropTypes.func,
    // Implicit props
    intl: intlShape
});
export default Sidebar;
